import { render, staticRenderFns } from "./RegistDataPanel.vue?vue&type=template&id=732d21d7&scoped=true&lang=pug&"
import script from "./RegistDataPanel.vue?vue&type=script&lang=ts&"
export * from "./RegistDataPanel.vue?vue&type=script&lang=ts&"
import style0 from "./RegistDataPanel.vue?vue&type=style&index=0&id=732d21d7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d21d7",
  null
  
)

export default component.exports